import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import SideCart from "@/components/SideCart";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import CheckoutReturn from "@/pages/CheckoutReturn";
import BookingDetail from "@/pages/BookingDetail";
import Admin from "@/pages/Admin";
import Embed from "@/pages/Embed";
import Survey from "@/pages/Survey";
import Profile from "@/pages/Profile";
import LandingPage from "@/pages/LandingPage";
import FlyerDrop from "@/pages/FlyerDrop";
import PodDetail from "@/pages/PodDetail";
import Locations from "@/pages/Locations";
import HowItWorks from "@/pages/HowItWorks";
import Inventory from "@/pages/Inventory";

function App() {
  return (
    <div className="App bg-brand-slate min-h-screen">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/locations" element={<Locations />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/inventory" element={<Inventory />} />
              <Route path="/pods/:slug" element={<PodDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/survey/:bookingId" element={<Survey />} />
              <Route path="/lp/:slug" element={<LandingPage />} />
              <Route path="/admin/flyer-drop" element={<FlyerDrop />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/booking/success" element={<CheckoutReturn />} />
              <Route path="/booking/:id" element={<BookingDetail />} />
              <Route path="/embed" element={<Embed />} />
            </Routes>
            <SideCart />
          </BrowserRouter>
          <Toaster richColors position="top-right" />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
